import type { PublicProductSummary } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { storeProductPath } from '@/shared/config';
import { cn } from '@/shared/ui';

interface FeaturedCardProps {
  readonly product: PublicProductSummary;
  /** 지금 장 — 옆에 살짝 보이는 다음 장들은 흐리게 둔다. */
  readonly isActive: boolean;
}

/** 이달의 상품 오른쪽 사진 카드 — 대표사진(없으면 이름만 적은 빈 판). 카드 전체가 상세 링크다. */
export const FeaturedCard = ({ product, isActive }: FeaturedCardProps): ReactElement => (
  <Link
    to={storeProductPath(product.id)}
    className={cn(
      'group block transition-opacity duration-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring motion-reduce:transition-none',
      isActive ? 'opacity-100' : 'opacity-50',
    )}
  >
    <div className="relative aspect-[4/5] overflow-hidden bg-white/10">
      {product.thumbnail !== null ? (
        <img
          src={product.thumbnail.url}
          alt=""
          loading="lazy"
          draggable={false}
          className="size-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
        />
      ) : (
        <span
          aria-hidden
          className="absolute inset-x-6 bottom-6 text-xl font-semibold text-white/60"
        >
          {product.name}
        </span>
      )}
    </div>
    {/* 사진은 장식이라 링크 이름은 상품명으로 준다. */}
    <span className="sr-only">{product.name} 상세 보기</span>
  </Link>
);
